module.exports = __webpack_public_path__ + "static/media/map-legend@2x.e6d50245.png";